import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { Subscription } from 'Internal.CommonAPI';
import { HubSpotWidget } from './HubSpot';
import { IntercomChatbotWidget } from './Intercom';
import UserlaneWidget from './Userlane';
import BeamerWidget from './Beamer';
import DelightedNPSWidget from './Delighted';

const Widgets: React.FC = () => {
  const { locale } = useIntl();
  const currentLocale = locale.toLowerCase();
  const queryClient = useQueryClient();
  const isTrialUser = queryClient.getQueryData([
    'account',
    'isTrialUser',
  ]) as boolean;
  const email = queryClient.getQueryData(['account', 'email']) as string;
  const country = queryClient.getQueryData(['account', 'country']) as string;
  const signUpDate = queryClient.getQueryData([
    'account',
    'signUpDate',
  ]) as Date;
  const id = queryClient.getQueryData(['account', 'id']) as number;
  const merchant_id = queryClient.getQueryData([
    'account',
    'merchant_id',
  ]) as string;
  const activeSubscriptions = queryClient.getQueryData([
    'account',
    'activeSubscriptions',
  ]) as Subscription[];

  if (email && id && isTrialUser !== undefined) {
    const showHubspot = isTrialUser;
    const showIntercom = isTrialUser === false;

    return (
      <>
        {showHubspot && (
          <HubSpotWidget
            email={email}
            locale={currentLocale}
            accountId={id}
            isTrialUser={isTrialUser}
          />
        )}
        {showIntercom && (
          <IntercomChatbotWidget
            email={email}
            accountId={id}
            merchantId={merchant_id || ''}
            isTrialUser={isTrialUser}
          />
        )}
        <BeamerWidget email={email} accountId={id} />
        {activeSubscriptions !== undefined &&
          signUpDate !== undefined &&
          country !== undefined && (
            <>
              <UserlaneWidget
                accountId={id}
                email={email}
                signUpDate={signUpDate}
                subscriptionsIds={activeSubscriptions.map(
                  (s) => s.subscription_plan.id
                )}
              />
              <DelightedNPSWidget
                accountId={id}
                email={email}
                country={country}
                subscriptions={activeSubscriptions}
              />
            </>
          )}
      </>
    );
  }

  return null;
};
export default Widgets;
